export const STORE_RESET_PASSWORD_TOKEN = "STORE_RESET_PASSWORD_TOKEN";
export const SET_DARK_MODE = "SET_DARK_MODE";
export const PLACEHOLDER =
  "https://storage.googleapis.com/college101-images/placeholder.png";
